import type { ZodType } from "zod";

/**
 * Runtime-validate an API response against its Zod schema.
 *
 * The schemas in `5-shared/types` were type-only until now, responses were cast
 * and trusted. This checks them at the boundary so backend drift surfaces
 * instead of silently rendering wrong data.
 *
 * Loud where it's cheap to fix (dev + tests throw), non-fatal in production
 * (warn and pass the raw data through) so a minor, harmless schema mismatch
 * never blanks a page for a real visitor.
 */
export function validate<T>(schema: ZodType<T>, data: unknown, label: string): T {
  const result = schema.safeParse(data);
  if (result.success) return result.data;

  console.warn(`[api] ${label}: response failed schema validation`, result.error.issues);
  if (import.meta.env.DEV) throw result.error;
  return data as T;
}
